import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';
import { PhoneApi } from './PersonPhoneApi';

/**
 * APIL Url: ADAC.Internet.Core.Models.ConsentManagementPhone
 * 
 * Endpoints: /api/v2/versicherungen/fahrrad/anlage
 */
export class ConsentManagementPhoneApi extends BaseApiModel {
	constructor(initialProperties?: Partial<ConsentManagementPhoneApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected telefon: PhoneApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.Phone
	 */
	get Telefon(): PhoneApi {
		return this.telefon;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.Phone
	 */
	set Telefon(value: PhoneApi) {
		this.telefon = value;
	}

	protected authorized: boolean;
	/**
	 * Description: dem Kanal wurde zugestimmt
	 * APIL Type: boolean
	 */
	get Authorized(): boolean {
		return this.authorized;
	}

	/**
	 * Description: dem Kanal wurde zugestimmt
	 * APIL Type: boolean
	 */
	set Authorized(value: boolean) {
		this.authorized = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): ConsentManagementPhoneApi {
		return AppUtils.Helper.createFromMap(dataObject, ConsentManagementPhoneApi, (key, value) => {
			switch (key.toLowerCase()) {
				case 'telefon':
					return PhoneApi.createFromObject(value);
				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		if (this.telefon) {
			result.Telefon = this.telefon.toRequestObject();
		}
		result.Authorized = this.authorized;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}